import { ListStateHandler } from "./ListStateHandler";
import { IS } from "@green24/npm-javascript-utils";

const reducer = (listingActionPrefix, itemActionPrefix, {initialState, customReducer} = {}) => {
	const handler = new ListStateHandler({
		initialState,
		actionPrefix: listingActionPrefix,
		itemActionPrefix,
	});

	return (state, action) => {
		if(IS.fnc(customReducer)) {
			const reducerResult = customReducer(state, action);
			if(reducerResult) return reducerResult;
		}

		handler.setState(state);

		return handler.handleAction(action);
	}
};

Object.defineProperty(reducer, "initialState", {value: ListStateHandler.model.defaultInitialState});

export default reducer;
